<template>
  <Input
    v-bind="$attrs"
    :value="value"
    @change="handleChange"
    class="indent-input"
    @blur="handleBlur"
    @focus="handleFocus"
    allowClear
  >
  <template slot="prefix" v-if="!searchFocus">
    <SvgIcon icon-class="search" />
  </template>
  </Input>
</template>
<script>
import { Input } from 'ant-design-vue'
export default {
  name: 'IndentInput',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  components: {
    Input
  },
  data() {
    return {
      searchFocus: false
    }
  },
  methods: {
    handleChange(evt) {
      this.$emit('change', evt.target.value.trim())
    },
    handleBlur(evt) {
      this.searchFocus = false
      this.$emit('blur', evt.target.value.trim())
    },
    handleFocus(evt) {
      this.searchFocus = true
      this.$emit('focus', evt.target.value.trim())
    }
  }
}
</script>
<style lang="less" scoped>
.indent-input {
    background: #eff3f8;
    border-radius: 8px;
    transition: all 0.5s;
    ::v-deep .ant-input {
      height: 42px;
      line-height: 42px;

      border-radius: 8px;
      border-width: 2px;
      font-size: 16px;

      background: #eff3f8;
      box-shadow: inset 0 0 10px 0 rgba(151, 171, 199, 0.15);
      border-color: transparent;

      &::placeholder {
        font-size: 16px;
        color: #6a6d73;
      }

      &:hover,&:focus {
        border-color: #236cff;
        border-right-width: 2px !important;
      }
    }
}

.ant-form-item-control.has-error .indent-input {
  & ::v-deep .ant-input {
      background: #fff8f8;
      border-color: #f5222d;

  }
}
</style>
